<template>
  <div class="default__container">
    <v-container class="order-details">
      <div class="header">
        <h1 class="header__title">{{ $t("message.payments.title") }}</h1>
      </div>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import { intercomMixin } from "@/helpers/mixins/intercom";

export default {
  name: "PaymentLayout",
  mixins: [intercomMixin],
  async created() {
    await this.setIntercom();
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  gap: $spacing * 3;
  padding: 0 $spacing * 2;

  &__title {
    @include font-size(30px);
  }
}
.order-details {
  max-width: 750px;
  display: flex;
  flex-direction: column;
  padding: $spacing * 2;
}
</style>
